import React from 'react'
import {
    ComposedChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';

const QuarterHistoricalPrice = ({ quarterHistoricalPrices }) => {
    const transformedMonthHistoricalPrices = transformData(quarterHistoricalPrices);

    return (
        <ResponsiveContainer width="100%" height={400}>
            <ComposedChart
                width={500}
                height={400}
                data={transformedMonthHistoricalPrices}
                margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20,
                }}
            >
                <CartesianGrid stroke="#f5f5f5" />
                <XAxis dataKey="labels" minTickGap={20} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="qx1" stroke="#05c46b" name='Quarter+1' />
                <Line type="monotone" dataKey="qx2" stroke="#ffa801" name='Quarter+2' />
                <Line type="monotone" dataKey="qx3" stroke="#3c40c6" name='Quarter+3' />
                <Line type="monotone" dataKey="qx4" stroke="#0652DD" name='Quarter+4' />
            </ComposedChart>
        </ResponsiveContainer>
    )
}

export default QuarterHistoricalPrice

function transformData(datasets) {
    // transform data to recharts format
    // For keys in the object, time is in labels and data is in key itself

    const transformedData = []

    // Get the length of the first dataset
    const length = datasets?.labels?.length

    for (let i = 0; i < length; i++) {
        // Insert first value of all the keys in the object
        const obj = {}

        Object.keys(datasets).forEach((key) => {
            obj[key] = datasets[key][i]
        })

        transformedData.push(obj)
    }

    return transformedData;
}